<template>
    <gofix-card fullContent class="mb-0">
        <gofix-default-table
            :settings="tableConfig"
            :table-items="tableItems"
            @new-item="openModalAdd"
            @load-items="getTableData"
            @row-click="edit"
            @delete-items="deleteItems"
            ref="gofixTable">
        </gofix-default-table>
        <b-modal :no-close-on-backdrop="true" id="modal-EditPrioritySet" :title="titleModal" hide-footer :centered="true" ref="modal-EditPrioritySet">
            <b-form class="pb-20">
                <b-row>
                    <b-col md="12">
                        <gofix-form-input label="Name" v-model="gl_account_names.name"></gofix-form-input>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right" v-if="$checkRole($accessModule.posting_rules, 'update')">
                <gofix-button label="SUBMIT" @click="saveGLAccountNames" :loading="isAction" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </gofix-card>
</template>
<script>
    import { filters } from '@/_filterVar.js'
    export default {
        name: 'gl-account-names',
        data() {
            return {
                tableConfig:{
                    name: 'posting-rules-gl-account-names',
                    controls:{
                        create: this.$checkRole(this.$accessModule.chart_of_account, 'create'),
                        delete: this.$checkRole(this.$accessModule.chart_of_account, 'delete')
                    },
                    filter: JSON.parse(JSON.stringify(filters['gl_account_names'])),
                    page: 1,
                    limit: 100,
                    total: 0,
                    sortColumn: "name",
                    sortDirection: "asc",
                },
                tableItems: [],
                isAction: false,
                gl_account_names: {},
                titleModal: 'Create GL Account Name',
            }
        },
        methods: {
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("PostingEntryController/getGLAccountNamesItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        console.log(err);
                        this.$alertNotification("Can not load items", "danger");
                        reject();
                    })
            },
            async deleteItems(callback) {
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("PostingEntryController/deleteGLAccountNames", ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'gl_account_name'))
                    })
                    .catch(err =>{
                        reject(err);
                    });
            },
            saveGLAccountNames(){
                if(this.isAction) {
                    return;
                }
                this.isAction = true;
                if (!this.gl_account_names.name) {
                    this.isAction = false
                    return this.$alertNotification("Name is a required field.", "danger");
                }
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                let keyMessage= 'adding'
                if(this.gl_account_names && this.gl_account_names.id) {
                    keyMessage = 'editing'
                }
                this.timer = setTimeout(() => {
                    this.$store.dispatch('PostingEntryController/saveGLAccountNames', this.gl_account_names)
                        .then(result => {
                            this.isAction = false;
                            this.$refs.gofixTable.reloadTableKeepFilter();
                            this.$alertNotification(this.$notificationV2(keyMessage, 'gl_account_name'));
                            this.$refs["modal-EditPrioritySet"].hide();
                        })
                        .catch(error => {
                            this.isAction = false;
                            if(error.response && error.response.data.error.message.error) {
                                return this.$alertNotification(error.response.data.error.message.error, "danger");
                            }
                        })
                }, 200)
            },
            edit(item){
                this.titleModal = 'Edit GL Account Name';
                this.gl_account_names = Object.assign({}, item);
                this.$refs['modal-EditPrioritySet'].show()
            },
            openModalAdd (){
                this.titleModal = 'Create GL Account Name'
                this.gl_account_names = {}
                this.$refs['modal-EditPrioritySet'].show()
            },
        }
    }
</script>
